import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["locale", "localization"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { StyledDayPicker } from './day-picker.styles';
import { DayPickerCaption } from './components/day-picker-caption';
import { getLocaleFile } from './day-picker.helpers';
import { jsx as _jsx } from "react/jsx-runtime";

var DayPicker = function DayPicker(_ref) {
  var locale = _ref.locale,
      localization = _ref.localization,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(StyledDayPicker, _objectSpread(_objectSpread({}, restProps), {}, {
    locale: locale || getLocaleFile(localization),
    components: {
      Caption: DayPickerCaption
    }
  }));
};

export { DayPicker };